
import { api } from './base';
import type { Notification } from '@/entities/notification';

export interface NotificationsListParams {
  limit?: number;
  offset?: number;
  unreadOnly?: boolean;
}

export const notificationsApi = {
  list: (params?: NotificationsListParams) => {
    const search = params
      ? '?' +
        Object.entries(params)
          .filter(([, v]) => v !== undefined)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
          .join('&')
      : '';
    return api.get<{ data: Notification[]; total: number }>(`/api/v1/notifications${search}`);
  },

  markAsRead: (id: string) =>
    api.patch<Notification>(`/api/v1/notifications/${id}/read`),

  markAllAsRead: () =>
    api.patch<{ ok: boolean }>('/api/v1/notifications/read-all'),

  markTicketAsRead: (ticketId: string) =>
    api.patch<{ updated: number }>(`/api/v1/notifications/read-by-ticket/${ticketId}`),

  getUnreadCount: () =>
    api.get<{ data: { count: number } }>('/api/v1/notifications/unread-count'),
};

export interface NotificationChannelOverride {
  inApp?: boolean;
  email?: boolean;
}

export interface NotificationSettings {
  userId: string;
  inApp: boolean;
  email: boolean;
  perEvent: Record<string, NotificationChannelOverride>;
  notifyGroupTickets: boolean;
  notifyAllTickets: boolean;
  availableEventTypes?: string[];
}

export const notificationSettingsApi = {
  get: () => api.get<NotificationSettings>('/api/v1/users/me/notification-settings'),
  update: (input: {
    inApp?: boolean;
    email?: boolean;
    perEvent?: Record<string, NotificationChannelOverride>;
    notifyGroupTickets?: boolean;
    notifyAllTickets?: boolean;
  }) =>
    api.put<NotificationSettings>('/api/v1/users/me/notification-settings', input, { toast: false }),
};
